import React from 'react';

interface MailIconProps {
  width?: string;
  height?: string;
  className?: string;
}

const MailIcon: React.FunctionComponent<MailIconProps> = ({
  width = '24',
  height = '24',
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0,0,256,256"
      className={className}
    >
      <g
        fill="#ffffff"
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit="10"
        strokeDasharray=""
        strokeDashoffset="0"
        fontFamily="none"
        fontWeight="none"
        fontSize="none"
        textAnchor="none"
      >
        <g transform="scale(5.12,5.12)">
          <path d="M0,8v34h36.49609c-0.646,-0.643 -1.31881,-1.314 -2.00781,-2h-32.48828v-2.23437l14.01367,-10.9082c1.21605,1.03244 3.24989,2.77388 3.53516,3.00195c1.834,1.572 3.72317,1.74023 4.45117,1.74023c0.362,0 1.01288,-0.04239 1.79688,-0.27539l-0.31055,-0.31055c-0.307,-0.307 -0.63214,-0.80862 -0.74414,-1.39062l-0.02734,-0.09766c-0.324,0.06 -0.58084,0.07422 -0.71484,0.07422c-0.394,0 -1.78678,-0.09125 -3.17578,-1.28125c-1.374,-1.099 -16.68922,-14.23245 -18.82422,-16.06445v-2.25391h44v2.25391c-1.254,1.075 -7.0512,6.04631 -11.9082,10.19531c0.03,0.038 0.0638,0.06347 0.0918,0.10547l1.32031,1.32031c3.831,-3.273 8.21114,-7.02933 10.49414,-8.98633v19.48242l2,2v-28.37109zM2,14.88867c2.89295,2.48062 8.2224,7.03997 12.45508,10.64648l-12.45508,9.69727zM25.94141,22c-0.29034,-0.00005 -0.55117,0.11169 -0.70117,0.33594c-0.2,0.299 -0.30117,0.69614 -0.20117,0.99414l1.70703,6.00195c0.047,0.164 0.129,0.30774 0.25,0.42773c3.995,3.977 15.74903,15.67188 15.83203,15.67188l0.30078,0.29883c1.599,1.593 4.19592,1.792 5.79492,0c1.499,-1.593 1.40039,-3.98278 -0.09961,-5.67578l-0.29883,-0.29688l-0.16211,-0.16211l-0.24023,-0.23828l-15.56836,-15.50977c-0.125,-0.124 -0.28117,-0.21281 -0.45117,-0.25781l-5.86523,-1.55273c-0.1,-0.025 -0.20009,-0.03709 -0.29687,-0.03711zM27.43945,24.42578l3.99805,1.0957l15.33789,15.17969l-2.94922,2.9375l-0.04687,0.04688l-15.14062,-15.17773z"></path>
        </g>
      </g>
    </svg>
  );
};

export default MailIcon;
